import AnimationSymbol from "@base/symbols/AnimationSymbol";
import Config from "@/config/Config";

export default class MultiplierAnimationSymbol extends AnimationSymbol {

    constructor(data) {
        super(data)
    }

    init(index) {
        super.init(index)
        this.IndexMultiplier = Number(Config.multiplierSymbol)
    }

    startSpin(valueMult) {
        this.symbolName = ''
        let nameAnimation = 'stop_ani'
        if (this.symbolIndex === this.IndexMultiplier){
            nameAnimation = valueMult + 'x_idle'
        }
        this.animations[this.currentSymbolName].start([nameAnimation], [false])
    }

    changeTextureByIndex(index, valueMult) {
        this.valueMultiplier = valueMult
        super.changeTextureByIndex(index)
        // if (this.symbolIndex === this.IndexMultiplier){
        //     let nameAnimation = this.valueMultiplier + 'x_idle'
        //     this.animations[this.currentSymbolName].start([nameAnimation], [false])
        // }
    }


    showAnimationStop(){
        if (this.currentName !== 'win' ){
            if (this.symbolIndex !== this.IndexMultiplier){
                this.animations[this.currentSymbolName].stop()
            }
            if (this.symbolIndex === this.IndexMultiplier && this.currentName === 'create'){
                let nameAnimation = this.valueMultiplier + 'x_land_ani'
                this.animations[this.currentSymbolName].start([nameAnimation], [false])
            }
            this.currentName = 'stop'
        }
    }

    disappear(){
        this.currentName = 'disappear'
        let nameAnimation = 'disappear_ani'
        this.animations[this.currentSymbolName].stop()
        if (this.symbolIndex === this.IndexMultiplier){
            nameAnimation = this.valueMultiplier + 'x_idle'
        }
        this.animations[this.currentSymbolName].start([nameAnimation], [false], 1.3)
    }

    win(){
        this.currentName = 'win'
        this.animations[this.currentSymbolName].stop()
        let nameAnimation = 'win_ani'
        if (this.symbolIndex === this.IndexMultiplier){
            nameAnimation = this.valueMultiplier + 'x_idle'
        }
        this.animations[this.currentSymbolName].start([nameAnimation], [true])
        this.parent.addChild(this)
    }
}
